import React, { Fragment } from 'react';
import endsWith from 'lodash/endsWith';

import { LegacyDOMBridge } from '@confluence/legacy-dom-bridge';

const LINKS_TO_BE_REMOVED = ['#action-page-permissions-link'];
const LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION = ['#page-favourite', '#action-menu-link'];
const replacedPlaceholder = {
	elementName: 'span',
	attributes: {
		style: `display: none`,
	},
};

export function HideLegacyElements() {
	return (
		<Fragment>
			<LegacyDOMBridge
				selectors={LINKS_TO_BE_REMOVED}
				attempts={100}
				retryDelay={500} // Retry on every half second, 50 seconds in total.
				portalNode={null}
				replacePlaceholderWith={replacedPlaceholder}
			/>
			{endsWith(window.location.pathname, '/pages/viewinfo.action') && (
				<LegacyDOMBridge
					selectors={LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION}
					attempts={100}
					retryDelay={500}
					replacePlaceholderWith={replacedPlaceholder}
					portalNode={null}
				/>
			)}
		</Fragment>
	);
}
